import React from 'react';
import { Nav } from 'react-bootstrap';
import { Outlet, useNavigate } from 'react-router-dom';
import './Settings.css'; // Importando o CSS para estilização

const Settings = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex vh-100">
      {/* Menu Esquerdo */}
      <Nav className="flex-column bg-light p-2" style={{ width: '200px' }}>
        <Nav.Link className="settings-link" onClick={() => navigate('/main/settings/users')}>Usuários</Nav.Link>
        <Nav.Link className="settings-link" onClick={() => navigate('/main/settings/bases')}>Bases</Nav.Link>
      </Nav>

      {/* Conteúdo à Direita */}
      <div className="flex-grow-1">
        <Outlet />
      </div>
    </div>
  );
};

export default Settings;